export default {"src":"/_next/static/media/twitter-square.f6d60595.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};